import {GET, POST} from "@/services/gateway";

const listSnapshots = ({date, dateTo}) => {
  return POST('salesforce/snapshot/list', {date, dateTo})
}

//TUKA MODIFIKACIJA PREMA NOVO API
const createBackup = ({ selectedObjects }) => {
  return POST('salesforce/backup', {selectedObjects})
}

const exportSnapshot = ({
  snapshotDateTime,
  sourceIds,
  searchTerm,
  snapshotId,
  selectedIds,
  extension,
  code,
  storageDestinationId,
  dataType = '8',
  storageDestinationType = 0
}) => {
  return POST('salesforce/export', {
    snapshotDateTime,
    sourceIds,
    searchTerm,
    snapshotId,
    selectedIds,
    extension,
    storageDestinationId,
    dataType,
    storageDestinationType
  }, {code: code ? code : null})
}

const connectSetup = (data) => {
  return POST('salesforce/connectSetup', data)
}

const restoreSnapshot = ({
                           snapshotDateTime,
                           sourceIds,
                           searchTerm,
                           destinationType,
                           snapshotId,
                           selectedIds,
                           RestoreType,
                           code
                         }) => {
  return POST('salesforce/restore', {
    snapshotDateTime,
    sourceIds,
    searchTerm,
    destinationType,
    snapshotId,
    RestoreType,
    selectedIds
  }, {code: code ? code : null});
}

const compareSnapshot = ({sourceIds, selectedIds, objectType, firstSnapshotDateTime, secondSnapshotDateTime, code}) => {
  let firstSnapshotDate = firstSnapshotDateTime;
  let secondSnapshotDate = secondSnapshotDateTime;

  if (firstSnapshotDate > secondSnapshotDate) {
    firstSnapshotDate = secondSnapshotDateTime;
    secondSnapshotDate = firstSnapshotDateTime;
  }

  return POST('salesforce/compare', {
    sourceIds,
    selectedIds,
    objectType,
    firstSnapshotDateTime: firstSnapshotDate,
    secondSnapshotDateTime: secondSnapshotDate
  }, {code: code ? code : null});
}

export {
  listSnapshots,
  createBackup,
  exportSnapshot,
  connectSetup,
  restoreSnapshot,
  compareSnapshot,
}
